"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizingMap = exports.sizeMap = void 0;
var styles = require("./SimpleModal.scss");
var SimpleModalProps_1 = require("./SimpleModalProps");
exports.sizeMap = new Map([
    [SimpleModalProps_1.SimpleModalSize.SMALL, styles.nModalSm],
    [SimpleModalProps_1.SimpleModalSize.MEDIUM, styles.nModalMd],
    [SimpleModalProps_1.SimpleModalSize.LARGE, styles.nModalLg],
    [SimpleModalProps_1.SimpleModalSize.EXTRA_LARGE, styles.nModalXLg],
    [SimpleModalProps_1.SimpleModalSize.SHEET, styles.nModalSt],
    [SimpleModalProps_1.SimpleModalSize.FULL_SCREEN, styles.nModalFs],
]);
exports.sizingMap = new Map([
    [SimpleModalProps_1.SimpleModalSizing.NORMAL, styles.nModalNormal],
    [SimpleModalProps_1.SimpleModalSizing.FULL, styles.nModalFull],
]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/SimpleModal/SimpleModalStylesMaps.js
// module id = 1679
// module chunks = 8